import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { Container, } from 'react-bootstrap';
import { withRouter } from './withRouter';

import Game from "./Games/Game";
import GamePack from "./Games/GamePack";
import GameAddon from './Games/GameAddon';
import GameList, { BestSellers as BestSellerIds } from "constants/GameList";
import GamePackList from "constants/GamePackList";
import GameAddonList from 'constants/GameAddonList';
import styles from './ShopStyles.module.scss'
import GameCityRewardsBanner from './Heros/GameCityRewardsBanner/GameCityRewardsBanner';
import BlackFridayBanner from './Heros/BlackFriday/BlackFridayBanner/BlackFridayBanner';
import ChristmasBanner from './Heros/ChristmasBanner/ChristmasBanner';

const categories = {
    all: {
        id: "all-products",
        shortName: 'all products',
        longName: 'all products',
    },
    individual: {
        id: "party-games",
        shortName: 'party games',
        longName: 'amazing party games',
    },
    //packs: {
    //    id: "party-game-packs",
    //    shortName: 'party packs',
    //    longName: 'party game packs',
    //},
    //addons: {
    //    id: "add-ons",
    //    shortName: 'add-ons',
    //    longName: 'party game add-ons',
    //},
};

class Shop extends Component {
    static displayName = Shop.name;

    constructor(props) {
        super(props);

        this.state = {
            filter: categories.all.id,
        };
    }

    componentDidMount() {
        // const queryParams = new URLSearchParams(window.location.search);
        // console.log(queryParams);
        // if (queryParams.has("roomId") && queryParams.has("sessionId")) {
        //     console.log("has params");
        //     setTimeout(() => this.props.navigate(`/join/?roomId=${queryParams.get("roomId")}&sessionId=${queryParams.get("sessionId")}`));
        // }
    }

    setFilter(value) {
        this.setState({ filter: value })
    }

    isDev() {
        return !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development'
    }

    isBlackFriday() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const startDate = new Date('2025-11-21T00:00:00');
        const endDate = new Date('2025-12-01T10:00:00');

        if (today >= startDate && today <= endDate) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        return (
            <div className={styles.pageShop}>
                {/*<section className={`${styles.heroBackground} ${styles.band}`}>*/}
                {/*    <Container className="text-center">*/}
                {/*        <h1>Our Games</h1>*/}
                {/*    </Container>*/}
                {/*</section>*/}

                {/*<section className={styles.filterSection}>*/}
                {/*    <Container className="text-center">*/}
                {/*        <ul className={styles.filterBar}>*/}
                {/*            {Object.entries(categories).map(([key, value]) => {*/}
                {/*                return <li onClick={() => this.setFilter(value.id)} className={(this.state.filter === value.id && styles.active)}>*/}
                {/*                    {value.shortName}*/}
                {/*                </li>*/}
                {/*            })}*/}
                {/*        </ul>*/}
                {/*    </Container>*/}
                {/*</section>*/}

                {
                    this.isBlackFriday() ?
                        <BlackFridayBanner showButton={false} shrinkAvatars={true} />
                        :
                        <>
                            {/*<GameCityRewardsBanner showBottomRibbon={false} color={"#05B139"} showTopRibbon={true} showShopButton={false} shrinkAvatars={true} />*/}
                            <ChristmasBanner showBottomRibbon={false} showTopRibbon={true} showShopButton={false} shrinkAvatars={true} />
                        </>
                }
                <section className={`${styles.gameListingSection} ${styles.band}`}>
                    <div className={styles.cloudBG} />
                    <Container>
                        {
                            [categories.individual.id, categories.all.id].includes(this.state.filter) &&
                            <div className={`${styles.shopGroup}`}>
                                <h2 id={categories.individual.id} className='mb-5' style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>TV GAME SHOWS</h2>
                                <div className='row justify-content-center'>
                                        {GameList.filter(g => g && (g.enabled || this.isDev()) && g.gameShow)
                                            .map(g => <div className='col-md-6 col-lg-4 text-center'><Game game={g} showAddToCart={true} /></div>)}
                                </div>
                            </div>
                        }
                        {
                            [categories.individual.id, categories.all.id].includes(this.state.filter) &&
                            <div className={`${styles.shopGroup} pb-5`}>
                                <div className={``} />
                                <h2 id={categories.individual.id} className='mb-5'>{categories.individual.longName.toUpperCase()}</h2>
                                <div className='row justify-content-center'>
                                        {GameList
                                            .filter(g => (g.enabled || this.isDev()) && !g.gameShow)
                                            .map(g => <div className='col-md-6 col-lg-4 text-center'><Game game={g} showAddToCart={true} /></div>)}
                                </div>
                            </div>
                        }
                        {/*{*/}
                        {/*    [categories.addons.id, categories.all.id].includes(this.state.filter) &&*/}
                        {/*    <div className={`${styles.shopGroup} pb-5`}>*/}
                        {/*        <div className={` `} />*/}
                        {/*        <h2 id={categories.addons.id} className='mb-5'>{categories.addons.longName.toUpperCase()}</h2>*/}
                        {/*        <div className='row justify-content-center'>*/}
                        {/*            {GameAddonList.filter(a => a.enabled || this.isDev()).map(a => <div className='col-md-6 col-lg-4 text-center'><GameAddon addon={a} /></div>)}*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*}*/}
                        {/*{*/}
                        {/*    [categories.packs.id, categories.all.id].includes(this.state.filter) &&*/}
                        {/*    <div className={`${styles.shopGroup} pb-5`}>*/}
                        {/*        <div className={``} />*/}
                        {/*        <h2 id={categories.packs.id} className='mb-5'>{categories.packs.longName.toUpperCase()}</h2>*/}
                        {/*        <div className='row justify-content-center'>*/}
                        {/*            {GamePackList.filter(g => g.enabled || this.isDev()).map(g => <div className='col-md-6 col-lg-4 text-center'><GamePack game={g} /></div>)}*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*}*/}
                        <div className={styles.cityScape} />
                    </Container>
                </section>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
}

export default connect(mapStateToProps, null)(withRouter(Shop));
